import LazyRoute from 'approot/shared/routes/lazy-route';
import {
  PRIVATE_CLASSES_PARAM,
  PRIVATE_CREATE_AI,
} from 'global/private-routes.constants';

import { FEATURE_CREATE_AI } from './create-ai.constants';

/**
 * The Create AI surface is registered as a single `/*` wildcard so the flow can
 * own its own nested `<Routes>` — every step URL is then inside one flag-gated
 * route and inherits `featureCreateAI` without re-declaring it.
 *
 * Both the class-prefixed and bare forms are registered, matching how the nav
 * links to the surface.
 */
const createAiRoutes = [
  {
    path: [
      `${PRIVATE_CLASSES_PARAM}${PRIVATE_CREATE_AI}/*`,
      `${PRIVATE_CREATE_AI}/*`,
    ],
    component: LazyRoute(
      () => import('./create-ai-flow'),
      true,
      false,
      FEATURE_CREATE_AI
    ),
  },
];

export default createAiRoutes;
